<template>
  <DxSankey
    :data-source="chartData"
    source-field="source"
    target-field="target"
    weight-field="weight"
    :palette="options.colors ? options.colors : null"
    class="px-4"
  >
    <DxTooltip
      :enabled="true"
      :customize-link-tooltip="options.linkTooltip"
      :customize-node-tooltip="options.nodeTooltip"
    />
    <DxNode :width="8" :padding="30" />
    <DxLink color-mode="gradient" />
  </DxSankey>
</template>

<script>
  import DxSankey, { DxTooltip, DxNode, DxLink } from 'devextreme-vue/sankey'

  export default {
    components: {
      DxSankey,
      DxTooltip,
      DxNode,
      DxLink,
    },

    props: {
      selectedDate: {
        type: Object,
        default: () => ({}),
      },
      options: {},
      data: {},
    },

    computed: {
      filteredData() {
        if (this.selectedDate.month === null && this.selectedDate.year === null) {
          return this.data
        } else if (this.selectedDate.month === null) {
          return this.data.filter(gasto => {
            return gasto.data.ano === this.selectedDate.year
          })
        } else {
          return this.data.filter(gasto => {
            return (
              gasto.data.ano === this.selectedDate.year &&
              gasto.data.mes === this.selectedDate.month
            )
          })
        }
      },

      chartData() {
        if (!this.filteredData.length) {
          return []
        }

        const negativeFirst = ['Renda']
        const positiveFirst = ['Variável', 'Investimento', 'Fixo']

        const flows = {}
        let data = []
        let center = String(this.selectedDate.text)
        let firstLevel = [...new Set(this.filteredData.map(e => e.tipo))]
        let secondLevel = [...new Set(this.filteredData.map(e => e.categoria.nome))]

        const startEdgeMap = (a, b) => {
          flows[a] = flows[a] || {}
          flows[b] = flows[b] || {}
          flows[a][b] = 0
          flows[b][a] = 0
        }

        const addEdgeMap = (first, second, value) => {
          if (value > 0) {
            flows[center][first] += value
            flows[first][second] += value
          } else {
            flows[second][first] += -value
            flows[first][center] += -value
          }
        }

        const getLabels = (from, to) => {
          let source = from
          let target = to
          const empty = '&nbsp;'

          // differentiate second level origins and destinations from one another
          if (secondLevel.includes(from)) {
            source = from + empty
          }
          if (secondLevel.includes(to)) {
            target = to + empty + empty
          }

          // differentiate first level origins and destinations when they cross over
          if (positiveFirst.includes(from) && secondLevel.includes(to)) {
            source = from + empty
          }
          if (from === center && positiveFirst.includes(to)) {
            target = to + empty
          }
          if (secondLevel.includes(from) && negativeFirst.includes(to)) {
            target = to + empty
          }
          if (negativeFirst.includes(from) && to === center) {
            source = from + empty
          }

          return {
            source,
            target,
          }
        }

        const addEdge = (from, to) => {
          if (flows[from][to]) {
            data.push({
              weight: flows[from][to],
              ...getLabels(from, to),
            })
          }
        }

        // create base value for all mappings
        firstLevel.forEach(a => {
          startEdgeMap(center, a)
          secondLevel.forEach(b => {
            startEdgeMap(a, b)
          })
        })

        this.filteredData
          .map(item => {
            // some values get switched horizontally
            let valor
            if (negativeFirst.includes(item.tipo)) {
              valor = -parseFloat(item.valor)
            } else {
              valor = parseFloat(item.valor)
            }
            return {
              ...item,
              valor,
            }
          })
          .forEach(item => {
            // sum each value to mappings
            const first = item.tipo
            const second = item.categoria.nome
            const value = item.valor

            addEdgeMap(first, second, value)
          })

        // build sankey data
        firstLevel.forEach(first => {
          addEdge(first, center)
          addEdge(center, first)

          secondLevel.forEach(second => {
            addEdge(first, second)
            addEdge(second, first)
          })
        })

        return data
      },
    },
  }
</script>

<style></style>
